/**
 * Modale distributeur
 * Le bouton porte l'ISO en data-distributor (ex: "MX"),
 * sauf le bouton "Autres pays" qui porte "autres".
 * Clone le template Blade pré-rendu correspondant.
 * Flowbite gère l'ouverture/fermeture via data-modal-target/toggle.
 */

export const initDistributorModal = (): void => {
    const contentEl = document.getElementById('distributor-content');
    const modalInner = document.getElementById('distributor-modal-inner');
    if (!contentEl || !modalInner) return;

    document.querySelectorAll<HTMLElement>('[data-distributor]').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.distributor!;
            const isFallback = id === 'FR' || id === 'autres';
            const tplKey = isFallback ? 'fallback' : id;

            let tpl = document.querySelector<HTMLTemplateElement>(`template[data-distri-tpl="${tplKey}"]`);
            if (!tpl) tpl = document.querySelector<HTMLTemplateElement>('template[data-distri-tpl="fallback"]');

            if (tpl) {
                contentEl.innerHTML = '';
                contentEl.appendChild(tpl.content.cloneNode(true));
            }

            const usedFallback = tpl?.dataset.distriTpl === 'fallback';
            const count = tpl?.dataset.distriCount ? parseInt(tpl.dataset.distriCount) : 0;
            modalInner.classList.remove('max-w-fit', 'max-w-2xl', 'max-w-3xl', 'max-w-[720px]', 'max-w-[482px]');
            modalInner.classList.add(usedFallback || count > 1 ? 'max-w-[720px]' : 'max-w-[482px]');
            modalInner.style.minHeight = window.innerWidth >= 640 ? 'min(563px, 80vh)' : '';
        });
    });
};
